const product_edit = {
    page_title: "Product Information",
    view_title: "View product",
    edit_title: "Edit item",
    add_title: "Add new product",
    btn_createSize: "Generation Specification",
    fl_category: "Product Category",
    fl_brand: "Product Brand",
    fl_name: "Product name",
    fl_serial: "Item No.",
    fl_labels: "Product Label",
    fl_unit: "Unit of Measure",
    fl_material: "Main Material",
    fl_objects: "Applicable object",
    fl_content: "Product Introduction",
    fl_size: "Product Specifications",
    fl_quantity: "Item Inventory",
    fl_originPrice: "Original price",
    fl_price: "Item price",
    fl_warnQuantity: "Inventory Alert",
    fp_category: "product category",
    fp_brand: "product brand",
    fp_name: "product name",
    fp_serial: "item number",
    form_ph5: "product label",
    fp_unit: "unit of measurement",
    fp_material: "main material",
    fp_objects: "applicable object",
    fp_content: "product description",
    form_ph10: "specifications",
    fp_quantity: "product inventory",
    fp_originPrice: "original price",
    fp_price: "price",
    fp_warnQuantity: "inventory warning",
    table_title: "Product Specification Table",
    tl_originPrice: "Original Price",
    tl_price: "Sale Price",
    tl_quantity: "Item Inventory",
    tl_warnQuantity: "Inventory Warning Value",
    tl_skuNo: "SKU number",
    btn_reUpdate: "Reupload",
    btn_update: "Click to upload",
    photos_title: "Product Album",
    btn_mainPhoto: "Product main image",
    btn_setMain: "Set as main image",
    btn_removePhoto: "Delete picture",
    btn_reUpdatePhoto: "Re-upload pictures",
    btn_updatePhoto: "Upload product pictures",
    row_label1: "Price",
    row_label2: "Item No.",
    row_newest: "New",
    row_promotion: "Promotion",
    row_hot: "Hot Sale",
    row_recommend: "Recommended",
    dialog_title1: "Commodity warehousing",
    dialog_label1: "Add Inventory",
    dialog_btn1: "Search",
    em_priceRule:
        "The price of the product must be less than or equal to the original price of the product",
    em_price: "Please enter a number with at most two decimal places",
    em_serialRequire: "Please enter the item number",
    em_serialRule: "Item number can only be a number",
    em_name: "Please enter the product name",
    em_quantity: "Please enter product inventory",
    em_originalPrice: "Please enter the original price of the product",
    em_shopPrice: "Please enter the product price",
    em_category: "Please select a product category",
    em_brand: "Please select a product brand",
    em_content: "Please enter product description",
    em_warnQuantity: "Please enter a commodity inventory warning",
    em_warnQuantityRule: "Inventory alert must be a numeric value",
    em_photoMin: "At least one main image is reserved",
    em_dateRequire: "Please fill in the data in the form before submitting",
    em_tatbleDate: "The form data is not completed",
    em_priceWrong: "The sale price cannot be greater than the original price",
    em_tablePriceRule:
        "The price in the specification table can only be entered with numbers, and at most two decimal places",
    em_priceNeed:
        "The price can only be entered as a number with a maximum of two decimal places"
};

export default product_edit;
